// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"882":"89d77b23","941":"012036ff"}[chunkId] + ".chunk.css";
};